import fetch from '@/utils/fetch';
import { message } from 'antd';

const model = {
  state: {
    roleParams: {
      pageNo: 1,
      pageSize: 10,
      // scope: 'FS',
    },
    tableLoading: false,
    roleList: [],
    permissionList: [],
    relationRoleParams: {
      pageNo: 1,
      pageSize: 10,
    },
    relationRoleList: [],
    relationRoleTotal: 0,
    accountParams: {
      pageNo: 1,
      pageSize: 10,
    },
    noRelevanceAccountList: [], // 未关联用户列表
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { privilege }, getState }) => ({
    async getRoleList() {
      privilege.setState({ tableLoading: true });
      const { roleParams } = getState().privilege;
      const params = {
        ...roleParams,
      };
      const data = await fetch('/saasmerchant/web/auth/role/getlist', {
        type: 'GET',
        params,
      });
      if (data) {
        privilege.setState({ roleList: data.data, roleTotal: data.total });
      }
      privilege.setState({ tableLoading: false });
    },
    async getPermissionList() {
      const data = await fetch('/saasmerchant/web/auth/category/tree/permission', {
        type: 'GET',
        params: {
          platformCode: 'FS',
        },
      });
      if (data) {
        const permissionList = privilege.mapTree(data);
        privilege.setState({ permissionList });
      }
    },
    mapTree(data) {
      const permissionList = [];
      data.forEach((items) => {
        const obj = {
          title: `菜单-${items.node.categoryName}`,
          key: `categoryId-${items.node.categoryId}`,
          children: [],
          checkable: false,
        };
        if (items.children && items.children.length > 0) {
          obj.children = privilege.mapTree(items.children);
        } else {
          items.node.permissions &&
            items.node.permissions.forEach((child) => {
              obj.children.push({
                title: `权限点-${child.permissionName}`,
                key: `${child.permissionId}`,
                checkable: true,
              });
            });
        }
        permissionList.push(obj);
      });
      return permissionList;
    },

    handlePage(pageNo, pageSize) {
      privilege.setState({ roleParams: { ...getState().privilege.roleParams, pageNo, pageSize } });
    },
    handleFilter(filters) {
      privilege.setState({ roleParams: { ...getState().privilege.roleParams, ...filters } });
    },
    // 删除角色
    async deteteRole(params) {
      const data = await fetch('/saasmerchant/web/auth/role/remove', {
        type: 'POST',
        params,
        useJson: true,
      });
      if (data) {
        message.success('删除成功');
        const { roleParams } = getState().privilege;
        privilege.setState({ roleParams: { ...roleParams, pageNo: 1 } });
      } else {
        message.error('删除失败');
      }
    },
    // 编辑角色
    async editRole(params, history) {
      const data = await fetch('/saasmerchant/web/auth/role/edit', {
        type: 'POST',
        params,
        useJson: true,
      });
      if (data) {
        message.success('编辑成功');
        const { roleParams } = getState().privilege;
        privilege.setState({ roleParams: { ...roleParams, pageNo: 1 } });
        history.push('/privilege/role');
      } else {
        message.error('编辑失败');
      }
    },
    // 新增角色
    async addRole(params, history) {
      const data = await fetch('/saasmerchant/web/auth/role/create', {
        type: 'POST',
        params: { ...params, platformCode: 'FS' },
        useJson: true,
      });
      if (data) {
        message.success('新增成功');
        const { roleParams } = getState().privilege;
        privilege.setState({ roleParams: { ...roleParams, pageNo: 1 } });
        history.push('/privilege/role');
      } else {
        message.error('新增失败');
      }
    },
    setRelationRoleFilter(params) {
      const { relationRoleParams } = getState().privilege;
      privilege.setState({ relationRoleParams: { ...relationRoleParams, ...params } });
    },
    initRelationRoleFilter() {
      privilege.setState({ relationRoleParams: { pageNo: 1, pageSize: 10 } });
    },
    // 获取角色关联用户
    async getRelationRoleList(relationParams = {}) {
      const { relationRoleParams } = getState().privilege;
      const params = {
        ...relationRoleParams,
        ...relationParams,
        platformCode: 'FS',
      };
      const data = await fetch('/saasmerchant/web/auth/role/getRelationRole', {
        type: 'POST',
        params,
        useJson: true,
      });
      if (data) {
        privilege.setState({ relationRoleList: data.data, relationRoleTotal: data.total });
      }
    },
    // 获取角色未关联的用户
    async getNotRelevanceList(params) {
      const data = await fetch('/saasmerchant/web/auth/role/notRelation', {
        params,
      });
      if (data) {
        privilege.setState({
          noRelevanceAccountList: data.data,
          noRelevanceAccountTotal: data.total,
        });
      } else {
        privilege.setState({
          noRelevanceAccountList: [],
          noRelevanceAccountTotal: 0,
        });
      }
    },
    // 移除角色关联的用户
    async removeRoleAccount(params) {
      const data = await fetch('/saasmerchant/web/auth/role/removeRoleAccount', {
        type: 'POST',
        params,
        // useJson: true,
      });
      if (data) {
        privilege.setRelationRoleFilter({ pageNo: 1 });
      } else {
        message.error('移除用户失败');
      }
    },
    // 角色关联用户
    async relationRoleAccount(params) {
      const data = await fetch('/saasmerchant/web/auth/role/relation', {
        type: 'POST',
        params: {
          ...params,
          platformCode: 'FS',
        },
        useJson: true,
      });
      if (data) {
        privilege.setRelationRoleFilter({ pageNo: 1 });
      } else {
        message.error('关联用户失败');
      }
    },
    initFilter() {
      privilege.setState({
        roleParams: {
          pageNo: 1,
          pageSize: 10,
          // scope: 'FS',
        },
      });
    },
  }),
};

export default model;
